import styles from './ContactHero.module.css';
import ContactImage from '../../assets/sam14.webp';

const ContactHero = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.imageContainer}>
        <img src={ContactImage} alt="Contact" />
      </div>
      <div className={styles.textContainer}>
        <h1 className={styles.heading}>
          WANNA MAKE IT MORE <br />
          OFFICIAL THAN A DM?
        </h1>
        <p className={styles.subtext}>
          Drop me a line & I will return your inquiry ASAP!
        </p>
      </div>
    </section>
  );
};

export default ContactHero;
